<template>
  <div>
    <div class="tw-font-bold tw-mb-2">
      Symbol Proxies
    </div>
    <p class="tw-text-sm tw-text-gray-500 tw-mb-2">
      Map symbols not in our system to a proxy ticker for optimization. If the real symbol exists in our system after optimization, it will be substituted back.
    </p>

    <div
      v-if="unprociedUnresolved.length > 0"
      class="tw-mb-3 tw-p-3 tw-bg-yellow-50 tw-border tw-border-yellow-300 tw-rounded"
    >
      <div class="tw-font-medium tw-text-yellow-800 tw-mb-1">
        Symbols not in our system (no proxy defined):
      </div>
      <div class="tw-flex tw-flex-wrap tw-gap-2">
        <span
          v-for="symbol in unprociedUnresolved"
          :key="symbol"
          class="tw-bg-yellow-100 tw-text-yellow-800 tw-px-2 tw-py-0.5 tw-rounded tw-text-sm tw-font-mono tw-cursor-pointer"
          title="Click to add a proxy for this symbol"
          @click="addProxyForSymbol(symbol)"
        >
          {{ symbol }}
        </span>
      </div>
      <p class="tw-text-xs tw-text-yellow-700 tw-mt-1">
        Click a symbol to add a proxy for it.
      </p>
    </div>

    <button
      class="tw-bg-blue-500 tw-text-white tw-px-2 tw-py-1 tw-rounded"
      @click="addProxy"
    >
      + Add Proxy
    </button>
    <div
      v-for="(proxy, index) in checkupStore.symbolProxies"
      :key="index"
      class="tw-mt-2 tw-flex tw-items-center tw-gap-2"
    >
      <input
        v-model="proxy.originalSymbol"
        class="tw-p-1 tw-border tw-rounded tw-uppercase"
        placeholder="Real symbol"
        @input="proxy.originalSymbol = proxy.originalSymbol.toUpperCase()"
      >
      <span class="tw-text-gray-500">→</span>
      <input
        v-model="proxy.proxySymbol"
        class="tw-p-1 tw-border tw-rounded tw-uppercase"
        placeholder="Proxy symbol"
        @input="proxy.proxySymbol = proxy.proxySymbol.toUpperCase()"
      >
      <button
        class="tw-bg-red-500 tw-text-white tw-px-2 tw-py-1 tw-rounded"
        @click="removeProxy(index)"
      >
        Remove
      </button>
    </div>
    <hr>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'SymbolProxySettings',
  computed: {
    ...mapStores(useCheckupStore),
    proxiedSymbols() {
      return new Set(
        this.checkupStore.symbolProxies
          .map(p => p.originalSymbol.toUpperCase())
          .filter(s => s)
      );
    },
    unprociedUnresolved() {
      return this.checkupStore.unresolvedTaxLotSymbols.filter(
        s => !this.proxiedSymbols.has(s.toUpperCase())
      );
    },
  },
  methods: {
    addProxy() {
      this.checkupStore.symbolProxies.push({ originalSymbol: '', proxySymbol: '' });
    },
    addProxyForSymbol(symbol) {
      this.checkupStore.symbolProxies.push({ originalSymbol: symbol, proxySymbol: '' });
    },
    removeProxy(index) {
      this.checkupStore.symbolProxies.splice(index, 1);
    },
  },
};
</script>
